const recurrenceOptions = [
    { value: 'daily', label: { en: 'Daily', es: 'Diario' } },
    { value: 'weekly', label: { en: 'Weekly', es: 'Semanal' } },
    { value: 'biweekly', label: { en: 'Biweekly', es: 'Quincenal' } },
    { value: 'monthly', label: { en: 'Monthly', es: 'Mensual' } },
    { value: 'bimonthly', label: { en: 'Bimonthly', es: 'Bimensual' } },
    { value: 'quarterly', label: { en: 'Quarterly', es: 'Trimestral' } },
    { value: 'yearly', label: { en: 'Yearly', es: 'Anual' } },
];

export default recurrenceOptions;